const es = {
    aftersales:{
        "contactus":"Contacta con nosotros para una respuesta rápida",
        "workorder":"La lista de orden de trabajo",
        "createjob":"Crear una orden de trabajo",
        "submittinworkorder":"Al enviar una orden de trabajo, incluya tanta información detallada como sea posible, como capturas de errores, información de la cuenta, etc., que son muy importantes para que podamos solucionar los problemas rápidamente.",
        "subscriptionaccount":"Cuenta de suscripción",
        "problemtype":"Tipo de problema",
        "tobeprocessed":"Para ser procesado",
        "processed":"Procesada",
        "revoked":"Revocado",
        "create":"Crear",
        "workorderno":"Número de Orden de trabajo",
        "product":"Producto",
        "status":"Estado",
        "type":"Tipo",
        "ticket":"Orden de trabajo",
        "createtime":"Tiempo de creación",
        "reply":"responder",
        "operate":'funcionar',
        "onlinechat":"chat en línea",
        "resolveworkorder":"Lo resolveremos lo antes posible después de enviar su orden de trabajo.",
        "noworkorder":"Sin orden de trabajo",
        "revoke":"Revocar",
        "content":"Contenido"
    },
    excode:{
        "redemptioncode":"Código de canje",
        "pleaseredemptioncode":"Por favor ingresa el código de canje",
        "exchange":"intercambio",
        "notused":"nunca usado",
        "used":"Usado",
        "expired":"Caducado",
        "status":"Estado",
        "exchangetime":"Intercambio por tiempo",
        "createtime":"Tiempo de creación",
        "selectactivityarea":"Por favor seleccione área de actividad",
        "optionaltraintickets":"Entradas opcionales",
        "newpurchase":"Nueva compra",
        "renew":"Renovación"
    },
    header:{
        "personaldetails":"información personal"
    },
    footer:{
        "contactus":"Contacta con nosotros",
        "navigation":"Navegación",
        "home":"Casa",
        "friends":"Con amigos",
        "subscribe":"Suscribir",
        "aftersales":"Servicio postventa",
        "help":"Ayuda",
        "termsofuse":"Condiciones de uso",
        "refundpolicy":"Politica de reembolso",
        "privacypolicy":"Política de privacidad",
        "paymentmethod":"Método de pago",
        "language":"Idioma",
        "map":"mapa del sitio",
        "homescreen":"Pantalla de inicio",
        "setpreferences":"Establece tus preferencias",
        "setlanguage":"Por favor configura tu idioma"
    },
    friends:{
        "promotioninfo":"información de promoción",
        "currentlevel":"nivel actual",
        "content":"Puede usar enlaces promocionales exclusivos y códigos de descuento para compartir con otros para ganar comisiones. Cuanto mayor sea el nivel, mayor será la cuota de comisión.",
        "rolemembers":"Puedes invitar a amigos, mayor sea el nivel, mayores descuentos y premios obtendrás.",
        "promotionallinks":"enlace de promoción",
        "discountcodes":"códigos de descuento",
        "copy":"copiar",
        "rebateratio":"ratio de comisión",
        "discountratio":"ratio de descuento",
        "lowestdiscountratio":"descuento mínimo",
        "walletsandpoints":"monedero y puntos",
        "applywithdrawal":"Después de solicitar el retiro, revisaremos y realizaremos el pago dentro de los 3 días hábiles.",
        "withdraw":"retiro",
        "record":"registro",
        "integral":"puntos",
        "pointsused":"Los puntos se pueden utilizar en sorteos.",
        "orderdetails":"detalles de la orden",
        "orderamount":"importe de la orden",
        "earnings":"ingresos",
        "withdrawalsrecord":"registro de retiros",
        "accounts":"cuenta",
        "accounttype":"Tipo de cuenta",
        "withdrawalamount":"cantidad de retiro",
        "cancel":"Cancelar",
        "submit":"entregar",
        "greaterthan":"El monto del retiro debe ser mayor que 30!",
        "normal":"normal",
        "invalid":"inválido",
        "bankcard":"trjeta de crédito",
        "promotionlink":"enlace de promoción",
        "discountcode":"código de descuento",
        "waitingforapproval":"A la espera de la aprobación",
        "waitingforpayment":"A la espera del pago",
        "notpass":"no pasar",
        "paid":"pagado",

        "cashwithdrawalid":"número de retiro",
        "accountsreceivable":"cuentas por cobrar",
        "amount":"cantidad",
        "status":"estado",
        "applicationtime":"tiempo de aplicación",
        "processingresults":"resultados del procesamiento",

        "sku":"sku",
        "orderid":"número de orden",
        "useramount":"identificación de usuario",
        "duration":"duración de compra",
        "promotiontype":"tipo de promoción",
        "createtime":"tiempo de creación",
        "eainings":"Ingresos (USD)",

        "receivingaccount":"cuenta receptora",
        "nowithdrawableamount":"sin cantidad retirable",
        "copysuccessfully":"copia exitosa",
        "copyfailed":"copia fallida",
        "salesvolume":"volumen de ventas",
        "nodata":"Aún no hay datos"
    },
    home:{
        'notice':'Click getNfcode to get the solution to Netflix unable to log in',
        'join':'Participar',
        'Renewal':'Renovar',
        "texttitle":"Suscripción compartida de bajo precio",
        "buynow":"Comprar ahora",
        "soldout":"Producto agotado",
        "delivery":"Entrega en tiempo real",
        "after":"Entrega en tiempo real después del pago sin esperas",
        "certificate":"Certificación SSI",
        "payments":"Pago en un entorno seguro certificado por SSI",
        "onlinesupport":"Soporte en línea 24 horas al día, 7 días a la semana",
        "privatecustomer":"Servicio al cliente privado en línea 24 horas al día, 7 días a la semana",
        "subscriber":"Derechos del suscriptor",
        "subscriptions":"Suscripción compartida de bajo precio, dando prioridad a la coincidencia de suscriptores en el nivel de servicio del mismo país.",
        "moneyback":"garantía de reembolso.",
        "refund":"Tienes entre 1 a 20 días para solicitar un reembolso",
        "parkingspace":"plaza de aparcamiento",
        "gift":"regalo",
        "screen":"Sub-cuenta",
        "1screen":"una subcuenta",
        "maxnum":"sub-cuenta",
        "month":"Mes",
        "buytyp":"Tipo de compra",
        "subscription":"suscripción",
        "voucher":"Vale",
        "discountcode":"Código de descuento",
        "use":"Usar",
        "paymentmethod":"Método de pago",
        "pleasechoose":"por favor seleccione",
        "billingdetails":"Detalles de facturación",
        "payaddress":"Detalles de la dirección de facturación",
        "firstname":"Apellido",
        "lastname":"Nombre",
        "emailaddress":"Dirección de correo electrónico",
        "phone":"Teléfono",
        "country":"Nación",
        "state":"provincia",
        "city":"Ciudad",
        "address":"Dirección",
        "housenumber":"Número de calle",
        "suiteunit":"Apartamento, suite, unidad, etc. (opcional)",
        "zipcode":"Código postal",
        "submit":"Entregar",
        "creditcard":"Tarjeta de crédito",
        "cardnumber":"Número de tarjeta",
        "expirydate":"Fecha de caducidad",
        "nameoncard":"Nombre en la tarjeta",
        "savethiscard":"Guarde esta tarjeta para la tarjeta predeterminada",
        "play":"Entregar",
        "emailerror":"ERROR de correo electrónico",
        "payresluttitle":"Pago exitoso",
        "Pleaseconfirmsuk":"por favor ingrese",
        "buytips": "Somos una cuenta familiar compartida. Una compra solo puede ser utilizada por una persona.\n" +"No se puede comprar el navegador Safari para iPhone. Utilice un navegador diferente.\n"+
        "Después de completar su compra de YouTube, envíe su dirección de correo electrónico en la página de suscripción.",
        "pleaseenter":"por favor ingrese",
        "selectamonth":"Por favor seleccione un mes",
        "selectthenumber":"Por favor seleccione el número de subcuentas",
        "selectthepurchase":"Por favor seleccione el tipo de compra",
        "selectthepayment":"Por favor seleccione el método de pago",
        "discountcodenotempty":"¡El código postal no puede estar vacío!",
        "detail1":
        // "<p>✅ Puedes usarlo sin que te afecten los cambios de política de Netflix.</p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>5 personas comparten 1 cuenta de suscripción</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Planeamos vender servicios de suscripción a tragamonedas en el futuro.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>4K, HDR, Dolby</span></p>"+
            "<p><i class=\"el-icon-check\"></i> <span>Si hay algún problema durante el uso, le reembolsaremos su dinero.</span></p>\n",
        "detail2":"<p><i class=\"el-icon-check\"></i> <span>Plan premium</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Sonido de alta fidelidad</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Entrega en tiempo real</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Mobile, PC, Tab</span></p>\n" +
            "<div id=\"gtx-trans\" style=\"position: absolute; left: 110px; top: 77.3906px;\">\n" +
            "<div class=\"gtx-trans-icon\">&nbsp;</div>\n" +
            "</div>",
        "detail3":"<p><i class=\"el-icon-check\"></i> <span>Plan premium</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>6 personas comparten 1 cuenta de suscripción</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Móvil, ordenador, televisión</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Registros privados de visualización de películas</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Mantenga todos sus favoritos y listas</span></p>",
        "detail5":"<p><i class=\"el-icon-check\"></i> <span>Servicio premium</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Plan premium</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Después de completar su compra, envíe su correo electrónico en la página de suscripción..</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Puede utilizar su cuenta existente tal como está.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Mantenga todos sus favoritos y listas</span></p>\n" +
            // "<p>✅ Consejo: antes de realizar una compra, asegúrese de que el país de su cuenta sea KR, ES, FR, PL, IT, DE, NL, GB, CA, US, JP, GR, CH, LT, PA, SG en play.google.com. . , CZ, SE, PT, BE, IL.</p>\n" +
            "<div id=\"gtx-trans\" style=\"position: absolute; left: -51px; top: 143.094px;\">\n" +
            "<div class=\"gtx-trans-icon\">&nbsp;</div>\n" +
            "</div>",
        "detail7":"<p><i class=\"el-icon-check\"></i><span>Renovar la misma suscripción</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Mantenga todos sus favoritos y listas</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Entrega en tiempo real</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Garantía de reembolso.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Antes de comprar, verifique si max está disponible abriendo el siguiente enlace: https://www.max.com/</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Suscripción compartida</span></p>",
        "detail8":"<p><i class=\"el-icon-check\"></i><span>Modelo Oficial 4.0</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Disfruta de la tienda GPT</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Complemento real disponible</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Prohibición de API</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>El contenido de la conversación está protegido y otros no pueden verlo</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Las condiciones de conversación del modelo 4.0 no están restringidas</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Soporte posventa,24 horas reembolsos sin preocupaciones</span></p>",
        "detail9":"<p><i class=\"el-icon-check\"></i><span>4 personas comparten 1 suscripción.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Entrega en tiempo real</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Admite terminales móviles, PC, televisores y cajas de TV</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>4K, HDR, Dolby</span></p>",
        "detail10":"<p><i class=\"el-icon-check\"></i><span>Plan Premium, $2.99/mes/pantalla</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Enviar enlace de invitación en tiempo real</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Suscripción privada, guárdalo todo.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Favoritos y listas</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Garantía de reembolso.</span></p>",
        "detalle11":"<p><i class=\"el-icon-check\"></i><span>Cuenta separada</span></p >\n" +
            "<p><i class=\"el-icon-check\"></i><span>Una cuenta que solo puede ser utilizada por una persona</span></p >\n" +
            "<p><i class=\"el-icon-check\"></i><span>Suscripción privada, quédate con todo</span></p >\n" +
            "<p><i class=\"el-icon-check\"></i><span>No realizado por políticas de Netflix</span></p >\n" +
            "<p><i class=\"el-icon-check\"></i><span>No se necesita código de verificación</span></p >",
        "detail12":"<p><i class=\"el-icon-check\"></i> <span>No se requiere cuenta de ChatGPT</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Mensajes de chat protegidos</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Admite GPT-cho y GPT-cho-mini</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Compatible con GPT-4.1, GPT-4.5 y GPT-o3</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Los servidores de alto rendimiento garantizan su acceso estable</span></p>",
        "detail13":
            "<p><i class=\"el-icon-check\"></i><span>Plan Educación Plus (excluye Notion AI)</p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Libertad modular: elimina la confusión al cambiar de herramientas</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Workspace integrado: ahorro del 57% en herramientas</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Colaboración en tiempo real: coordinación de la demanda sin retraso</span></p>",
         "detail14":
            "<p><i class=\"el-icon-check\"></i><span>Disfruta de Super Duolingo</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Los miembros pueden disfrutar de un entorno de aprendizaje sin anuncios, evitando distracciones durante cada lección y enfocándose en el estudio</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Use el ‘Customized Practice’ feature to correct errors during practice</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Los miembros pueden desafiar el nivel legendario más alto indefinidamente, dominar el contenido aprendido en profundidad y mejorar sus habilidades de idioma</span></p>",
        "lowerpricesharelarge":"Comparta suscripciones premium a precios más bajos en",
        "lowerpricesharesmall":"Comparta suscripciones premium a precios más bajos en <span class='green-text-2'>AlongShare</span>",
        "highqualitystreaming":"Proporcionando alta calidad y bajo precio durante 3 años consecutivos.",
        "detail":"comprobar los detalles",
        "moreactivities":"Muchas actividades, muchas ganancias.",
        "sharejoinsubscription":"<span class='green-text-2'>Compartir</span>Únete a la cooperación",
        "shareyoursubscription":"Compartir junto con amigos",
        "availabletime":"Con código de descuento exclusivo",
        "makemoney":"Alguien más compró usando su código de descuento",
        "widerangesubscription":"Puede obtener los reembolsos de pedidos correspondientes",
        "threestepsshare":"Los detalles del pedido de promoción se pueden ver en el panel de comisiones.",
        "joinsubscription":"Únase a la cooperación",
        "saveupsubscriptionfees":"Publicación automática de publicaciones/vídeos promocionales en Naver/YouTube/Telegram.",
        "securepayment":"La promoción incluye su propio código de descuento.",
        "manualreview":"Después de la promoción, puede verificar fácilmente el estado del pedido en la página \"추천 할인\"",
        "oneclickjoin":"Podrás retirar dinero cuando tu billetera acumule $30.",
        "whyusealongshare":"Por qué <span class='green-text-2'> cada vez más</span> personas utilizan <span class='green-text-2'> Alongshare</span>",
        "position":"{0} bits",
        "selectdiscount":"Seleccionar descuento",
        "notstoreinfo":"AlongShare no almacena la información de su tarjeta. Todas las transacciones están aseguradas, procesadas y autorizadas por un proveedor de pagos externo.",
        "alumpsum":"pago único",
        "details":"Detalles",
        "subtotal":"Total parcial",
        "promotioncodescoupons":"Códigos promocionales y cupones",
        "paymentfee":"tarifas de pago",
        "total":"total",
        "nowastediscount":"¡No desperdicies este descuento!",
        "hoursjoin":"Se unió hace {hours} horas",
        "minutesjoin":"Se unió hace {minutes} minutos"
    },
    login:{
        "welcomelogin":"Bienvenido a iniciar sesión",
        "login":"Iniciar sesión",
        "updatepwd":"Cambiar la contraseña",
        "reg":"Registrar una cuenta",
        "agreement":"Confirma que has leído y aceptas nuestros términos",
        "quicklogin":"Inicio de sesión rápido",
        "sendcode":"Enviar código",
        "register":"Registro",
        "changepassword":"Cambiar la contraseña",
        "verificationcode":"Código de verificación",
        "name":"Nombre",
        "password":"Contraseña",
        "agapassword":"Repita la contraseña",
        "modify":"Modificar",
        //"validatepswlen":"La contraseña se ajusta a letras mayúsculas y minúsculas, números y caracteres especiales ¡ la longitud de cualquier combinación de los tres de ellos es de entre 8 y 16!",
        "validatepswlen":"La contraseña debe contener cualquier letra, número, carácter especial",
        "checkagreement":"Por favor revisa el acuerdo",
        "passwordinconsistency":"¡Las contraseñas ingresadas dos veces son inconsistentes!",
        "passwordagain":"por favor ingrese la contraseña nuevamente",
        "verificationsend":"El código de verificación ha sido enviado, preste atención para verificar",
        "useemail":"o usa tu correo electrónico",
        "agree":"Al continuar, aceptas nuestra",
        "and":"y",
        "andconfirm":"y confirmar",
        "readour":"Has leído nuestro",
        "forgotpassword":"olvida la contraseña",
        "codelogin":"Inicie sesión usando el código de verificación",
        "verifyemail":"Verificar correo electrónico",
        "sendcodeemail":"Le enviaremos un código de verificación por correo electrónico a Ingresar verificación Completar registro {email}.",
        "continue":"continuar",
        "resend":"Reenviar",
        "noreceivecode":"¿No puedes aceptar el código de verificación?",
        "passwordlogin":"inicio de sesión con contraseña",
        "setpassword":"Establecer contraseña",
        "confirmpassword":"confirmar Contraseña"
    },
    luckdraw:{
        "lotteryticket":"premio",
        "integral":"puntos",
        "welcome":"Esta es nuestra página de actividades. Haz clic en la tarjeta para sacar una lotería.\n"+
        "Los premios incluyen varios paquetes de cuentas gratuitas\n"+
        "Códigos de descuento y otros descuentos, gracias por su apoyo y confianza..",
        "none":"nada",
        "redemptioncode":"código de canje",
        "copy":"copiar",
        "prizelist":"lista de premios",
        "notused":"Usado",
        "used":"Usar",
        "expired":"Caducado",

        "prizeno":"Número de premio",
        "contents":"Contenido del premio",
        "exchangedate":"Fecha de canje/fecha de uso",
        "createtime":"tiempo de creación",
        "exchange":"intercambio",
        "insufficientpoints":"Puntos insuficientes",
        "consumepoints":"Esta operación consumirá 10 puntos. ¿Continúas?",
        "tips":"Consejos",
        "comfirm":"confirmar",
        "cancel":"cancelar",
        "failtowin":"No ganar un premio",
        "congratulations":"Felicitaciones por obtener다",
        "copysucceeded":"¡Copia exitosa!",
        "copyfailed":"¡Copia fallida!",
    },
    subscribe:{
        "clickto":"Click to get link.",
        "Resend":"Have you already sent a new code back? Get it again",
        "getverificationlink":" Get login verification link",
        "getlinktips":"If you have not been asked to fill in the verification code,please ignorethis feature.",
        "renewnow":"Renovar ahora",
        "subscription":"Renovar la misma suscripción",
        "independent":"4K+HDR HD, registro de visualización independiente",
        "guarantee":"garantía de reembolso.",
        "timeleft":"Tiempo restante",
        "openingtime":"Hora de inicio de la cuenta",
        "endtime":"Hora de finalización",
        "account":"Cuenta",
        "password":"Contraseña",
        "profile":"Perfil",
        "pleaseuse":"por favor use",
        "subaccount":"sub-cuenta",
        "myprofile":"¡Alguien hace mal uso de mi perfil!",
        "renew":"Renovar",
        "aftersales":"Servicio postventa",
        
        "submitYoutube":"Después de enviar su dirección de correo electrónico, simplemente haga clic en el botón \n"+"Unirse para unirse al Grupo Hogar. Alternativamente, copie y abra el enlace a la cuenta de Google Chrome de la cuenta con la que desea unirse al Grupo Hogar.",
        "yourownsub":"1. Utilice su propia subcuenta según el número de serie.",
        "delete":"2.No modifique/elimine otras subcuentas",
        "modifysubscription":"3.No modifique la información relacionada con la suscripción.",
        "reminder":"Recordatorio: si tiene algún problema, Póngase en contacto con el servicio al cliente a tiempo, compre una suscripción en alongshare y disfrute del servicio al cliente VIP, sin necesidad de cambiar el número para renovar.",
    
        // "youtubeloginemail":"Ingrese su correo electrónico de inicio de sesión de YouTube. Deberá utilizar su dirección de correo electrónico de inicio de sesión para unirse a su grupo familiar. De lo contrario, te expulsarán de la familia. Si necesita ayuda, comuníquese con el servicio de atención al cliente de Alongshare por correo electrónico.",
        "youtubeloginemail":"Ingrese su correo electrónico de inicio de sesión de YouTube. Deberá utilizar la dirección de correo electrónico que ingresó para unirse a su grupo familiar. De lo contrario, te expulsarán de la familia. Si necesita ayuda, comuníquese con el servicio de atención al cliente en la parte inferior derecha.",
        "aftersalesservice":"servicio postventa",
        "support":"pagina de soporte",
        "submit":"entregar",
    
        "buyit":"Aún no hay suscripciones, date prisa para comprarla.",
        "paymentsucceeded":"Pago exitoso",
        "month":"Por favor seleccione un mes.",
        "number":"Por favor, seleccione el número de subcuentas",
        "purchase":"Por favor, seleccione el tipo de compra",
        "payment":"Por favor seleccione el método de pago",
        "name":"Por favor ingrese el nombre en la tarjeta",
        "card":"Por favor ingrese el número de tarjeta",
        "cvv":"Por favor ingrese CVV",
        "expirydate":"Por favor ingrese la fecha de vencimiento",
        "processing":"Se ha enviado el estado de procesamiento. Verifique el estado de procesamiento en la orden de trabajo.",
        "cannotempty":"¡El código de descuento no puede estar vacío!",
        "originalpassword":"La contraseña original para esta tarea ya no se utiliza. ¿Quieres continuar?",
        "passwordmeets":"La contraseña se ajusta a letras mayúsculas y minúsculas, números y caracteres especiales ¡ la longitud de cualquier combinación de los tres de ellos es de entre 8 y 16!"
    
    },
    userinfo:{
        "signout":"salir",
        "nickname":"Apodo",
        "avatar":"Avatar",
        "uploadavatar":"Por favor sube tu avatar",
        "logout":"¿Quieres cerrar sesión?",
        "onlyjpgpng":"Las fotos subidas son JPG | Sólo está disponible el formato png.",
        "cannotexceed":"¡El tamaño de las imágenes cargadas no puede exceder los 5 MB!",
        "exitalongshare":"¿Salir de AlongShare?",
        "personaldata":"datos personales",
        "clickimage":"Haga clic en la imagen para editar",
        "edit":"editar",
        "alongshareloginemail":"Correo electrónico de inicio de sesión de AlongShare",
        "save":"ahorrar",
        "resetpassword":"restablecer contraseña",
        "editpassword":"editar contraseña",
        "passwordmust":"Tu contraseña debe tener",
        "anycharacter":"Cualquier letra, número, carácter especial.",
        "twosamepasswords":"Las dos contraseñas que ingresaste son iguales",
        "currentpassword":"Contraseña actual",
        "newpassword":"Nueva contraseña",
        "confirmpassword":"confirmar Contraseña",
        "updatepassword":"Actualizar contraseña"
    },
    wish:{
        "wish":"Pide un deseo",
        "help":"AlongShare seleccionará algunos deseos para cumplir",
        "christmas":"se hacen realidad cuando llega la Navidad, deja tu deseo",
        "submit":"Entregar",
        "mywish":"mi deseo"
    },
    map:{
        "home":"Casa",
        "userinfo":"Información de usuario",
        "login":"Iniciar sesión",
        "withfriends":"Con amigos",
        "subscribe":"Suscribir",
        "aftersales":"Servicio postventa",
        "luckdraw":"Sorteo",
        "wish":"Pide un deseo",
        "helpcenter":"Centro de ayuda",
        "tradingstamps":"Página de canje",
        "affiliateprogram":"programa de afiliados",
        "order":"Orden"
    },
    order:{
        "whetherpayment":"Ya sea para pagar",
        "yes":"Sí",
        "no":"No"
    }
}

export default es
